import style from "./AppLayout.module.css";
import Header from "@/ui/header/Header";
import { Outlet } from "react-router-dom";
import Footer from "@/layouts/footer/Footer";

function AppLayout() {
	return (
		<div className={style.page}>
			<Header />
			<Outlet />
			<Footer />
		</div>
	);
}

export default AppLayout;
